import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import Checkbox from 'material-ui/Checkbox';
import { updatePlatformCheckbox, orgInitialState } from 'redux/modules/composeboxForm';
import { FormSection, PageHeader } from 'components';
import * as styles from './Composebox.scss';
var PostToArea = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    organization: state.organization.current,
    organizationId: state.organization.current.id
  };
}, {
  updatePlatformCheckbox: updatePlatformCheckbox
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PostToArea, _Component);

  var _super = _createSuper(PostToArea);

  function PostToArea(props) {
    var _this;

    _classCallCheck(this, PostToArea);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleCheck", function (e, checked) {
      var organizationId = _this.props.organizationId;

      _this.props.updatePlatformCheckbox(e.target.id, checked, organizationId);
    });

    _defineProperty(_assertThisInitialized(_this), "camelCaseIt", function (theString) {
      var stringArray = theString.split(' ');
      stringArray[0] = stringArray[0].toLowerCase();
      stringArray[1] = _.startCase(stringArray[1]);
      return stringArray.join('');
    });

    _this.state = {
      tokenExpiredAccounts: []
    };
    return _this;
  }
  /** *********************************************************
   LIFECYCLE METHODS
   ***********************************************************/


  _createClass(PostToArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          composeboxForm = _this$props.composeboxForm,
          organizationId = _this$props.organizationId;
      var connectedAccounts = this.props.organization.SocialAccounts.map(function (account) {
        return _this2.camelCaseIt(account.platform);
      });
      var tokenExpiredAccounts = [];
      this.props.organization.SocialAccounts.forEach(function (acct) {
        var tokenExpired = moment(acct.tokenValidUntil).isBefore(moment());
        var needsTokenRefresh = moment(acct.tokenValidUntil).isBefore(moment().add(10, 'days'));

        if (acct.platform == "Twitter") {
          needsTokenRefresh = false;
        }

        if (tokenExpired) {
          _this2.props.updatePlatformCheckbox(_this2.camelCaseIt(acct.platform), false, organizationId);

          tokenExpiredAccounts.push(_this2.camelCaseIt(acct.platform));
          toast.error( /*#__PURE__*/React.createElement("div", null, "Your ", acct.platform, " account needs to be reconnected. Go to the", ' ', /*#__PURE__*/React.createElement("span", {
            onClick: function onClick() {
              browserHistory.push("/org/".concat(_this2.props.organization.id, "/settings/social-accounts"));
            },
            className: styles.toastLink
          }, "Social Accounts"), ' ', "page to reconnect now."), {
            hideProgressBar: true,
            autoClose: false,
            position: 'bottom-left'
          });
        } else if (needsTokenRefresh) {
          toast.warning( /*#__PURE__*/React.createElement("div", null, "Your ", acct.platform, " account needs to be reconnected soon. Go to the", ' ', /*#__PURE__*/React.createElement("span", {
            onClick: function onClick() {
              browserHistory.push("/org/".concat(_this2.props.organization.id, "/settings/social-accounts"));
            },
            className: styles.toastLink
          }, "Social Accounts"), ' ', "page to reconnect now."), {
            hideProgressBar: true,
            autoClose: false,
            position: 'bottom-left'
          });
        }
      });
      this.setState({
        tokenExpiredAccounts: tokenExpiredAccounts
      });

      if (composeboxForm) {
        Object.keys(composeboxForm.selectedAccounts).forEach(function (key) {
          if (!connectedAccounts.includes(key) || key === 'facebookProfile') {
            _this2.props.updatePlatformCheckbox(key, false, organizationId);
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      toast.dismiss();
    }
    /** *********************************************************
     EVENT HANDLERS
     ***********************************************************/

  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this3 = this;

      var composeboxForm = this.props.composeboxForm;
      var validAccounts = this.props.organization.SocialAccounts.filter(function (sa) {
        return !['Facebook profile', 'Instagram[page_connected]'].includes(sa.platform);
      });

      var uniqValidAccounts = _.sortBy(_.uniqBy(validAccounts, 'platform'), 'platform');

      var checkboxes = uniqValidAccounts.map(function (account, index) {
        var labelText = account.platform;

        if (labelText === 'Twitter') {
          labelText = 'X (Twitter)';
        } else if (labelText === 'Google my business') {
          labelText = 'Google Business Profile';
        }

        var parsedPlatformName = _this3.camelCaseIt(account.platform);

        var selected = composeboxForm.selectedAccounts[parsedPlatformName];
        return /*#__PURE__*/React.createElement("div", {
          className: "col-xs-6",
          key: "".concat(account.platform, "_").concat(index),
          "data-checkboxplatform": "".concat(account.platform)
        }, /*#__PURE__*/React.createElement(Checkbox, {
          disabled: _this3.state.tokenExpiredAccounts.includes(parsedPlatformName),
          label: labelText,
          id: parsedPlatformName,
          checked: selected,
          onCheck: function onCheck(e, checked) {
            return _this3.handleCheck(e, checked);
          }
        }));
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          width: '100%'
        }
      }, checkboxes);
    }
  }]);

  return PostToArea;
}(Component)) || _class);
export { PostToArea as default };